// Brand contact + config — UPDATE THESE PLACEHOLDERS with real handles.
export const CONFIG = {
  instagramHandle: "yaza.exotics",
  instagramUrl: "https://instagram.com/yaza.exotics",
  // Deep link that opens the IG DM composer where supported.
  instagramDM: "https://ig.me/m/yaza.exotics",
  smsNumber: "+10000000000", // placeholder — replace with real text line
  smsDefaultBody: "Yo — I want to TAP IN on a YAZA drop.",
};

export const tapInSms = (text) =>
  `sms:${CONFIG.smsNumber}?&body=${encodeURIComponent(text || CONFIG.smsDefaultBody)}`;

export const BRAND = {
  name: "YAZA EXOTICS",
  short: "YAZA EXOTICS",
  tagline: "WHEN SERVICE AND GENETICS ARE TIER 1, THAT'S YAZA",
  metaDescription:
    "The sweet essence that delights taste buds worldwide with fruit lung candy and innovative strains.",
  parent: "DarkGrowers",
};
